import React from 'react';
import Dashboard from './dashboard';

export default function DashboardWrapper(props: Readonly<object>) {
    return <Dashboard {...props} />;
}
